  "use client"

  import { Component } from "react"
  import moment from "moment"
  import redux from "../common/Redux"
  import API from "../services/API"
  import Switch from "./Switch"
  import Checkbox from "@mui/material/Checkbox"
  import ConfirmationModal from "../components/ConfirmationModal"
  import noItemsImage from "../assets/Group 48.svg"
  import Toast from "./Toast"

  const ColorScheme = {
    buttonColor: "#FFC857",
    bgColor: "#02111B",
    componentColor: "#07070A",
    accentColor: "#BB0A21",
    textColor: "#FFFFFF",
  }

  class Table extends Component {
    constructor(props) {
      super(props)
      this.state = {
        data: [],
        noOfPages: 10,
        totalItem: 0,
        hasMore: false,
        page: 1,
        totalPage: 10,
        perPageItem: 15,
        orderBy: "id",
        orderType: "asc",
        search: "",
        version: 0,
        selectAll: false,
        selectedRows: [],
        isConfirmationModalOpen: false,
        itemToDelete: null,
        toast: {
          open: false,
          message: "",
          severity: "success",
        },
        isLoading: false,
      }
    }

    openConfirmationModal = (item) => {
      this.setState({ isConfirmationModalOpen: true, itemToDelete: item })
    }

    closeConfirmationModal = () => {
      this.setState({ isConfirmationModalOpen: false, itemToDelete: null })
    }

    handleDeleteConfirmation = () => {
      const { itemToDelete } = this.state
      if (itemToDelete && this.props.onDelete) {
        this.props.onDelete(itemToDelete)
      }
      this.closeConfirmationModal()
    }

    showToast = (message, severity) => {
      this.setState({
        toast: {
          open: true,
          message,
          severity,
        },
      })
    }

    handleCloseToast = (event, reason) => {
      if (reason === "clickaway") {
        return
      }
      this.setState({
        toast: {
          ...this.state.toast,
          open: false,
        },
      })
    }

    componentDidMount() {
      this.getData()
    }

    getData = async (ppage = 1) => {
      this.setState({ isLoading: true })

      const params = {
        page: ppage,
        perPageItem: this.state.perPageItem,
        orderBy: this.state.orderBy,
        orderType: this.state.orderType,
        search: this.state.search,
      }

      try {
        const { status, message, data: resdata } = await API(this, "get", this.props.api, params)
        console.log("API Response:", resdata)
        console.log("Current page from API:", resdata?.page)
        console.log("Total pages from API:", resdata?.totalPage || resdata?.last_page)
        console.log("Total items from API:", resdata?.totalItem || resdata?.total)

        // Always maintain pagination state even if no data
        this.setState({
          status,
          message,
          data: resdata?.data || [],
          page: Number.parseInt(resdata?.page || ppage),
          totalPage: Number.parseInt(resdata?.totalPage || resdata?.last_page || 1),
          totalItem: Number.parseInt(resdata?.totalItem || resdata?.total || 0),
          isLoading: false,
        })

        console.log("After setState - Current page:", Number.parseInt(resdata?.page || ppage))
        console.log("After setState - Total pages:", Number.parseInt(resdata?.totalPage || resdata?.last_page || 1))
      } catch (error) {
        console.error("API Error:", error)
        this.setState({
          isLoading: false,
          // Maintain current pagination state even on error
          page: ppage,
          totalPage: this.state.totalPage,
          totalItem: this.state.totalItem,
        })
        this.showToast("Failed to fetch data", "error")
      }
    }

    handleSearchChange = (e) => {
      clearTimeout(this.timer)
      this.setState({ search: e.target.value }, () => {
        this.timer = setTimeout(() => this.getData(1), 550) // Reset to page 1 when searching
        console.log("Search term changed to:", e.target.value)
      })
    }

    handlePerPageChange = (e) => {
      this.setState({ perPageItem: e.target.value }, () => {
        this.getData(1) // Reset to page 1 when changing items per page
        console.log("Items per page changed to:", e.target.value)
      })
    }

    handlePageChange = (pageNumber) => {
      console.log("Attempting to change to page:", pageNumber)
      console.log("Current page:", this.state.page)
      console.log("Total pages:", this.state.totalPage)

      if (pageNumber >= 1 && pageNumber <= this.state.totalPage) {
        this.setState({ page: pageNumber }, () => {
          this.getData(pageNumber)
          console.log("Page changed to:", pageNumber)
        })
      } else {
        console.log("Page change rejected - out of bounds")
      }
    }

    renderHeader = () => {
      const row = this.props.hideActions
        ? this.props.row
        : [...this.props.row, { title: "Action", key: "action", sortable: false }]
      return row.map(
        (item, index) =>
          item && (
            <th
              key={index}
              style={{
                color: ColorScheme.textColor,
                borderBottom: `1px solid ${ColorScheme.buttonColor}`,
                padding: "1rem",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>{item.title}</span>
                {item.sortable && (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.setState(
                        { orderBy: item.key, orderType: this.state.orderType === "asc" ? "desc" : "asc" },
                        () => this.getData(1), // Reset to page 1 when sorting
                      )
                    }}
                  >
                    {this.state.orderBy === item.key ? (this.state.orderType === "asc" ? "▲" : "▼") : "◆"}
                  </span>
                )}
              </div>
            </th>
          ),
      )
    }

    renderCell = (item, column,index) => {
      if (column.parse) {
        const parsedValue = column.parse(item)

        // Handle status badges (Material UI icons)
            if (column.type === "action") {
        if (!parsedValue) return null; // Don't render anything if parse returns null
        
        return (
          <div className="d-flex align-items-center h-100">
            <button
              className="btn btn-sm"
              style={{
                backgroundColor: parsedValue.color === "primary" ? ColorScheme.buttonColor : "#6c757d",
                color: parsedValue.color === "primary" ? ColorScheme.componentColor : "#ffffff",
                padding: "6px 12px",
                borderRadius: "4px",
                border: "none",
                opacity: parsedValue.disabled ? 0.6 : 1,
                cursor: parsedValue.disabled ? "not-allowed" : "pointer"
              }}
              onClick={parsedValue.onClick}
              disabled={parsedValue.disabled}
            >
              {parsedValue.text}
            </button>
          </div>
        );
      }
        if (column.type === "statusBadge") {
          return (
            <div className="d-flex align-items-center h-100">
              <span
                style={{
                  backgroundColor: parsedValue.bgColor,
                  color: parsedValue.textColor,
                  padding: "6px 10px",
                  borderRadius: "16px",

                  fontSize: "12px",
                  fontWeight: "bold",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  minWidth: "110px",
                  boxSizing: "border-box",
                }}
              >
                {parsedValue.icon}
                {parsedValue.text}
              </span>
            </div>
          )
        }
    
    if (column.parseFunction) {
      return column.parseFunction(item[column.key], item, index);
    }
        if (column.type === "paymentStatus") {
          return (
            <div className="d-flex align-items-center h-100">
              <span
                style={{
                  backgroundColor: parsedValue.bgColor,
                  color: parsedValue.textColor,
                  padding: "6px 10px",
                  borderRadius: "16px",

                  fontSize: "12px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  minWidth: "90px",
                  boxSizing: "border-box",
                  // border: `2px solid ${parsedValue.borderColor || parsedValue.textColor || "#000000"}`
                }}
              >
                {parsedValue.icon}
                {parsedValue.text}
              </span>
            </div>
          )
        }

        // Handle order type badges (image URLs)
        if (column.type === "typeBadge") {
          return (
            <div className="d-flex align-items-center h-100">
              <span
                style={{
                  backgroundColor: parsedValue.bgColor,
                  color: parsedValue.textColor,
                  padding: "6px 10px",
                  borderRadius: "16px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "4px",
                  minWidth: "120px",
                  boxSizing: "border-box",
                }}
              >
                {parsedValue.icon &&
                  (typeof parsedValue.icon === "string" ? (
                    <img
                      src={parsedValue.icon || "/placeholder.svg"}
                      alt=""
                      style={{
                        width: "14px",
                        height: "14px",
                      }}
                    />
                  ) : (
                    parsedValue.icon
                  ))}
                {parsedValue.text}
              </span>
            </div>
          )
        }

        return <div className="d-flex align-items-center h-100">{parsedValue}</div>
      }

      switch (column.type) {
        case "badge":
          return (
            <div className="d-flex align-items-center h-100">
              <span
                style={{
                  backgroundColor: "#9E9E9E",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                {item[column.key]}
              </span>
            </div>
          )
        case "switch":
          return (
            <div className="d-flex align-items-center h-100">
              <Switch
                checked={item[column.key]}
                onChange={(val) => {
                  if (column.onSwitch) column.onSwitch(item, val)
                  this.props.onSwitch?.(item, val)
                }}
              />
            </div>
          )
        case "icon":
          return (
            <div className="d-flex align-items-center h-100">
              <img src={item[column.key] || "/placeholder.svg"} width="full" height="80" className="" alt="icon" />
            </div>
          )
        case "date":
          return (
            <div className="d-flex align-items-center h-100">
              {!item[column.key] ? "Now / ASAP" : moment(item[column.key]).format(column.format || "DD/MM/YYYY, HH:mm")}
            </div>
          )
        case "date_from_now":
          return <div className="d-flex align-items-center h-100">{moment(item[column.key]).fromNow()}</div>
        case "render":
          return <div className="d-flex align-items-center h-100">{column.render(item)}</div>
        default:
          return (
            <div className="d-flex align-items-center h-100">
              {column.parseFunction ? column.parseFunction(item[column.key], item) : item[column.key]}
            </div>
          )
      }
    }

    renderActions = (item) => {
      const { isConfirmationModalOpen } = this.state

      return (
        <div className="d-flex align-items-center h-100">
          {this.props.onView && (
            <button
             variant="outlined"
                                size="small"
              className="btn btn-sm me-2 d-flex align-items-center"
              style={{ backgroundColor: "#00A651", color: "#ffffff" }}
              onClick={() => this.props.onView(item)}
            >
              <i className="fa fa-eye me-1" aria-hidden="true"></i> VIEW
            </button>
          )}
          {this.props.onEdit && (
            <button
              className="btn btn-sm me-2 d-flex align-items-center"
              style={{
                backgroundColor: ColorScheme.buttonColor,
                color: ColorScheme.componentColor,
              }}
              onClick={() => this.props.onEdit(item)}
            >
              <i className="fa fa-pencil me-1" aria-hidden="true"></i> EDIT
            </button>
          )}
          {this.props.onDelete && (
            <button
              className="btn btn-sm d-flex align-items-center"
              style={{
                backgroundColor: ColorScheme.accentColor,
                color: ColorScheme.textColor,
              }}
              onClick={() => this.openConfirmationModal(item)}
            >
              <i className="fa fa-trash me-1" aria-hidden="true"></i> DELETE
            </button>
          )}

          <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            onConfirm={this.handleDeleteConfirmation}
            onCancel={this.closeConfirmationModal}
            title={this.props.deleteTitle || "Confirm Deletion"}
            message={this.props.deleteText || "Are you sure you want to delete this item?"}
            confirmText="Yes, delete it!"
            cancelText="Cancel"
          />
        </div>
      )
    }

    renderEmptyState = () => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px 20px",
            minHeight: "300px",
            width: "100%",
            color: ColorScheme.textColor,
          }}
        >
          <img
            src={noItemsImage || "/placeholder.svg"}
            alt="No Items Available"
            style={{
              maxWidth: "200px",
              width: "100%",
              marginBottom: "20px",
            }}
          />
          <h4 style={{ color: ColorScheme.buttonColor, marginBottom: "10px", textAlign: "center" }}>No Data Found</h4>
          <p style={{ textAlign: "center", maxWidth: "500px", color: "#999" }}>
            {this.state.search
              ? "No data match your search criteria. Try adjusting your filters or search terms."
              : "There are no data to display. Items will appear here once they are added."}
          </p>
        </div>
      )
    }

    pageNumbers = (current, total) => {
      if (total <= 0) return []

      const result = []
      for (let i = Math.max(1, current - 2); i <= Math.min(current + 2, total); i++) {
        result.push(
          <li key={i} className={`page-item ${current === i ? "active" : ""}`}>
            <button
              className="page-link"
              onClick={() => this.handlePageChange(i)}
              style={{
                backgroundColor: current === i ? ColorScheme.buttonColor : ColorScheme.componentColor,
                color: current === i ? ColorScheme.componentColor : ColorScheme.textColor,
                border: "none",
              }}
            >
              {i}
            </button>
          </li>,
        )
      }
      return result
    }

    // Add this method to your Table class
    exportToCSV = () => {
      const { data } = this.state

      if (!data || data.length === 0) {
        this.showToast("No data to export", "warning")
        return
      }

      try {
        // Get column headers from props.row
        const headers = this.props.row
          .filter((column) => column) // Filter out any null/undefined columns
          .map((column) => column.title)

        // Get all the data keys from props.row
        const keys = this.props.row.filter((column) => column).map((column) => column.key)

        // Create CSV content
        let csvContent = headers.join(",") + "\n"

        // Initialize totals
        let totalGST = 0
        let totalTip = 0
        let totalAmount = 0

        // Add data rows
        data.forEach((item) => {
          // Calculate totals - extract numeric values from the data
          // For GST, we need to extract just the number part from the formatted string
          const gstValue = Number.parseFloat(item.order_tax_total || 0)
          totalGST += gstValue

          // For tip, extract the numeric value
          const tipValue = Number.parseFloat(item.waiter_tip || 0)
          totalTip += tipValue

          // For the total amount
          const amountValue = Number.parseFloat(item.order_grand_total || 0)
          totalAmount += amountValue

          const rowData = keys
            .map((key) => {
              const column = this.props.row.find((col) => col && col.key === key)
              let cellValue = item[key]

              // Handle special column types
              if (column && column.type) {
                switch (column.type) {
                  case "date":
                    cellValue = !item[key] ? "Now / ASAP" : moment(item[key]).format(column.format || "DD/MM/YYYY, HH:mm")
                    break
                  case "date_from_now":
                    cellValue = moment(item[key]).fromNow()
                    break
                  case "switch":
                    cellValue = item[key] ? "Yes" : "No"
                    break
                  case "statusBadge":
                  case "paymentStatus":
                  case "typeBadge":
                    if (column.parse) {
                      const parsed = column.parse(item)
                      cellValue = parsed.text || ""
                    }
                    break
                }
              }

              // Handle parseFunction if available
              if (column && column.parseFunction) {
                cellValue = column.parseFunction(item[key], item)
              }

              // Format cell value for CSV
              if (cellValue === null || cellValue === undefined) {
                return ""
              }
              // Escape quotes and wrap in quotes if the value contains commas or quotes
              if (typeof cellValue === "string") {
                if (cellValue.includes(",") || cellValue.includes('"') || cellValue.includes("\n")) {
                  return '"' + cellValue.replace(/"/g, '""') + '"'
                }
              }
              return cellValue
            })
            .join(",")

          csvContent += rowData + "\n"
        })

        // Add total row
        const totalRow = keys
          .map((key) => {
            if (key === "order_tax_total") {
              return `₹${totalGST.toFixed(2)} (Total GST)`
            } else if (key === "waiter_tip") {
              return `₹${totalTip.toFixed(2)}`
            } else if (key === "id") {
              return "TOTAL"
            } else if (key === "order_grand_total") {
              return `₹${totalAmount.toFixed(2)}`
            } else {
              return ""
            }
          })
          .join(",")

        csvContent += totalRow + "\n"

        // Create a blob and download the file
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")

        // Set file name (use props.exportFileName or default)
        // const fileName = `${this.props.exportFileName }_${Date.now()}.csv`
              const fileName = `${this.props.exportFileName }.csv`


        link.setAttribute("href", url)
        link.setAttribute("download", fileName)
        link.style.visibility = "hidden"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.showToast("CSV export successful", "success")
      } catch (error) {
        console.error("Export error:", error)
        this.showToast("Failed to export data", "error")
      }
    }

    render() {
      const { data, totalPage, page } = this.state
      const hasData = Array.isArray(data) && data.length > 0
      const shouldShowPagination = this.props.pagination !== false && totalPage > 0

      return (
        <div style={{ backgroundColor: ColorScheme.bgColor, color: ColorScheme.textColor, padding: "2rem" }}>
          {/* Top section with export button that's always visible */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center">

            </div>

            {/* Search input that shows only when there's data */}
          
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={this.props.searchPlaceholder || "Search..."}
                  style={{
                    backgroundColor: "transparent",
                    color: ColorScheme.textColor,
                    boxShadow: "none",
                    paddingRight: "2.5rem",
                  }}
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                  disabled={this.state.isLoading}
                />
                <i
                  className="fa fa-search position-absolute"
                  style={{ right: "1rem", top: "50%", transform: "translateY(-50%)" }}
                ></i>
              </div>
          
          </div>

          {/* Per page selector that shows only when there's data */}
          {hasData && (
            <div className="d-flex justify-content-start align-items-center mb-4">
              <div className="d-flex align-items-center">
                <select
                  className="form-select me-3"
                  style={{
                    backgroundColor: "#02111B",
                    color: ColorScheme.textColor,
                    boxShadow: "none",
                  }}
                  value={this.state.perPageItem}
                  onChange={this.handlePerPageChange}
                >
                  {[5, 10, 15, 25, 50, 100].map((num) => (
                    <option key={num} value={num}>
                      {num} per page
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {this.state.isLoading ? (
            <div className="text-center py-5">
              {/* <div className="spinner-border" role="status" style={{ color: ColorScheme.buttonColor }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading data...</p> */}
            </div>
          ) : hasData ? (
            <>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {!this.props.hideBulkAction && (
                        <th style={{ width: "50px", borderBottom: "1px solid #FFC857" }}>
                          <Checkbox
                            checked={this.state.selectAll}
                            onChange={(e) => {
                              const selectAll = e.target.checked
                              const selectedRows = selectAll ? this.state.data.map((item) => item.id) : []
                              this.setState(
                                {
                                  selectAll,
                                  selectedRows,
                                },
                                () => {
                                  if (this.props.onSelectedRowsChange) {
                                    this.props.onSelectedRowsChange(selectedRows)
                                  }
                                },
                              )
                            }}
                            style={{ color: ColorScheme.buttonColor }}
                          />
                        </th>
                      )}
                      {this.renderHeader()}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          cursor: this.props.onRowClick ? "pointer" : "default",
                          backgroundColor: index % 2 === 0 ? "transparent" : "#041A29",
                          borderBottom: "none",
                        }}
                        onClick={() => this.props.onRowClick && this.props.onRowClick(item)}
                      >
                        {!this.props.hideBulkAction && (
                          <td style={{ border: "none", verticalAlign: "middle" }}>
                            <Checkbox
                              checked={this.state.selectedRows.includes(item.id)}
                              onChange={(e) => {
                                const selectedRows = e.target.checked
                                  ? [...this.state.selectedRows, item.id]
                                  : this.state.selectedRows.filter((id) => id !== item.id)
                                this.setState({ selectedRows }, () => {
                                  if (this.props.onSelectedRowsChange) {
                                    this.props.onSelectedRowsChange(selectedRows)
                                  }
                                })
                              }}
                              style={{ color: ColorScheme.buttonColor }}
                            />
                          </td>
                        )}
                        {this.props.row.map(
                          (column, cellIndex) =>
                            column && (
                              <td
                                key={cellIndex}
                                style={{ padding: "1rem", border: "none", verticalAlign: "middle", height: "80px" }}
                              >
                                {this.renderCell(item, column,index)}
                              </td>
                            ),
                        )}
                        {!this.props.hideActions && (
                          <td style={{ textAlign: "center", border: "none", verticalAlign: "middle" }}>
                            {this.renderActions(item)}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {this.props.pagination !== false && this.state.totalPage > 0 && (
                <div className="row mt-3">
                  <div className="col-12 col-md-6 mb-2 mb-md-0">
                    <div className="text-muted">
                      Showing {this.state.data.length > 0 ? (this.state.page - 1) * this.state.perPageItem + 1 : 0}
                      {" to "}
                      {Math.min(this.state.page * this.state.perPageItem, this.state.totalItem)}
                      of {this.state.totalItem} entries
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <nav aria-label="Page navigation">
                      <ul className="pagination pagination-sm justify-content-md-end justify-content-center mb-0">
                        <li className={`page-item ${this.state.page <= 1 ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => this.handlePageChange(this.state.page - 1)}
                            disabled={this.state.page <= 1}
                            style={{
                              backgroundColor: this.state.page <= 1 ? "#6c757d" : ColorScheme.buttonColor,
                              color: this.state.page <= 1 ? "#fff" : ColorScheme.componentColor,
                              border: "none",
                            }}
                          >
                            Previous
                          </button>
                        </li>

                        {/* Show first page */}
                        {this.state.page > 3 && (
                          <li className="page-item">
                            <button
                              className="page-link"
                              onClick={() => this.handlePageChange(1)}
                              style={{
                                backgroundColor: ColorScheme.componentColor,
                                color: ColorScheme.textColor,
                                border: "none",
                              }}
                            >
                              1
                            </button>
                          </li>
                        )}

                        {/* Show ellipsis if needed */}
                        {this.state.page > 4 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}

                        {/* Show current page and surrounding pages */}
                        {Array.from({ length: Math.min(5, this.state.totalPage) }, (_, i) => {
                          let pageNum
                          if (this.state.totalPage <= 5) {
                            pageNum = i + 1
                          } else if (this.state.page <= 3) {
                            pageNum = i + 1
                          } else if (this.state.page >= this.state.totalPage - 2) {
                            pageNum = this.state.totalPage - 4 + i
                          } else {
                            pageNum = this.state.page - 2 + i
                          }

                          return (
                            <li key={pageNum} className={`page-item ${this.state.page === pageNum ? "active" : ""}`}>
                              <button
                                className="page-link"
                                onClick={() => this.handlePageChange(pageNum)}
                                style={{
                                  backgroundColor:
                                    this.state.page === pageNum ? ColorScheme.buttonColor : ColorScheme.componentColor,
                                  color: this.state.page === pageNum ? ColorScheme.componentColor : ColorScheme.textColor,
                                  border: "none",
                                }}
                              >
                                {pageNum}
                              </button>
                            </li>
                          )
                        })}

                        {/* Show ellipsis if needed */}
                        {this.state.page < this.state.totalPage - 3 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}

                        {/* Show last page if needed */}
                        {this.state.page < this.state.totalPage - 2 && (
                          <li className="page-item">
                            <button
                              className="page-link"
                              onClick={() => this.handlePageChange(this.state.totalPage)}
                              style={{
                                backgroundColor: ColorScheme.componentColor,
                                color: ColorScheme.textColor,
                                border: "none",
                              }}
                            >
                              {this.state.totalPage}
                            </button>
                          </li>
                        )}

                        <li className={`page-item ${this.state.page >= this.state.totalPage ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => {
                              console.log("Next button clicked")
                              console.log("Current page:", this.state.page)
                              console.log("Total pages:", this.state.totalPage)
                              if (this.state.page < this.state.totalPage) {
                                this.handlePageChange(this.state.page + 1)
                              }
                            }}
                            disabled={this.state.page >= this.state.totalPage}
                            style={{
                              backgroundColor:
                                this.state.page >= this.state.totalPage ? "#6c757d" : ColorScheme.buttonColor,
                              color: this.state.page >= this.state.totalPage ? "#fff" : ColorScheme.componentColor,
                              border: "none",
                            }}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              )}
            </>
          ) : (
            this.renderEmptyState()
          )}

          <Toast
            open={this.state.toast.open}
            message={this.state.toast.message}
            severity={this.state.toast.severity}
            handleClose={this.handleCloseToast}
          />
        </div>
      )
    }
  }

  export default redux(Table)
